import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import React from 'react';
import { ReportFooterTimestamp, tableCellStyle } from '../../../../utils/reportUtils';
import { ExistingPatientInvoiceResponse } from '../newPharmacy/newPharmacyForm.helper';

interface DrugListComponentProps {
  DrugListData?: ExistingPatientInvoiceResponse;
}

const DrugDispense: React.FC<DrugListComponentProps> = ({ DrugListData }) => {

  return (
    <Box sx={{ p: '0px 35px 35px 35px', backgroundColor: '#fff', color: '#333', fontFamily: 'Arial, sans-serif' }}>
      <Box component="hr" sx={{ my: 2, borderColor: '#ccc' }} />
      <Typography variant="h6" sx={{ mb: 1, color: '#444' }}>{' Dispensed Drug List'}</Typography>
      <TableContainer component={Paper} elevation={0} sx={{  mb: 4 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {[
                'Code',
                'Drug Name',
                'Generic Name',
                'Dispensed No.',
                'Strength',
                'UOM',
                'Batch no',
                'Billed Qty',
                'Remaining Qty',
                'Dispensed By',
                'Date',
              ].map((heading, i) => (
                <TableCell
                  key={i}
                  sx={{
                    ...tableCellStyle,
                    fontWeight: 'bold',
                    backgroundColor: '#f5f5f5',
                  }}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {/* eslint-disable-next-line */}
            {DrugListData?.data?.current_prescriptions.map((drugItem: any, i: number) => (
              <TableRow key={drugItem.id || i}>
                <TableCell sx={tableCellStyle}>{drugItem?.item_code ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.item_name ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.manufacturer ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.dispense_number ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.billed_strength ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.billed_uom ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.batch_number ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.billed_quantity ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.remaining_quantity ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{drugItem?.dispensed_by.full_name ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>
                  {drugItem?.created_on
                    ? new Date(drugItem.created_on).toLocaleDateString()
                    : '-'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ReportFooterTimestamp />

    </Box>
  );
};

export default DrugDispense;